import { ReactElement } from 'react';

import { Tooltip } from '@/design-system';
import { useSAMLEmptyState } from '@/hooks/useSAMLEmptyState';

interface SAMLEmptyStateTooltipProps {
  children: ReactElement;
  placement?: 'top' | 'bottom' | 'left' | 'right';
  className?: string;
}

export const SAMLEmptyStateTooltip = ({
  children,
  placement = 'right',
  className,
}: SAMLEmptyStateTooltipProps) => {
  const { isSAMLEmptyState } = useSAMLEmptyState();

  if (!isSAMLEmptyState) {
    return children;
  }

  return (
    <Tooltip
      title={
        <>
          <div>No workspaces available.</div>
          <div>Contact your administrator.</div>
        </>
      }
      side={placement}
    >
      <span className={className}>{children}</span>
    </Tooltip>
  );
};
